import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { isEmpty, cloneDeep } from 'lodash';

import BobTableContextMenu from '../../../components/BobTableContextMenu';
import { Grid, GridColumn as Column, getSelectedState } from '@progress/kendo-react-grid';

import BobModal from '../../../components/BobModal';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobActionMenu from '../../../components/BobActionMenu';
import ConfirmConfiguration from '../../../containers/Dashboard/Modals/ConfirmConfiguration';
import DeleteConfigurationModal from './DeleteConfigurationModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import { process as kendoProcess, filterBy, orderBy } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';

import queryString from 'query-string';

import * as BobActions from '../../../actions/bobActions';
import * as configurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const idGetter = getter('id');

const ConfigurationsTable = ({
    activeNavEquipment,
    activeNavCompany,
    bobLoading,
    bulkDeleteConfigurations,
    currentUser,
    allConfigurations,
    deleteConfiguration,
    fetchAllConfigurations,
    fetchSingleEquipment,
    fetchSingleSite,
    history,
    navEquipment,
    newConfiguration,
    resetNavOptions,
    saveConfiguration,
    setActiveConfiguration,
    setActiveNavEquipment,
    setNavEquipment,
    setWorkBookMode,
    workbookModeEnabled,
    ...props
}) => {
    
    const initialDataState = {
        filter: [],
        sort:   [],
        take:   10,
        skip:   0
    };

    const [configurationsList, setConfigurationsList] = useState([]);
    const [pageable] = useState({ pageSizes: true });
    const [selectedConfiguration, setSelectedConfiguration] = useState();
    const [action, setAction] = useState('');
    const [dataState, setDataState] = useState(initialDataState);
    const [selectedState, setSelectedState] = useState({});
    const [take, setTake] = useState(10);

    const init =  async () => {
        await fetchAllConfigurations(currentUser.id); 
    };

    useEffect(() => {
        if (currentUser && currentUser.id && activeNavCompany && activeNavCompany.id) init();
    },[currentUser, activeNavCompany]);

    // save as configuration
    useEffect(() => {
        const init =  async () => {
            const { viewName, isDefault, sharedEmails } = { ...newConfiguration };
            const { viewType, ownerId, viewKey, entityId, entityName, viewData } = { ...selectedConfiguration };

            let payload = {
                viewType,
                ownerId,
                viewKey,
                entityId,
                entityName,
                name:         viewName,
                isDefault:    isDefault,
                viewData:     JSON.stringify(viewData),
                sharedEmails: sharedEmails
            };

            await saveConfiguration(currentUser.id, payload);
            await fetchAllConfigurations(currentUser.id); 
        };

        if (!isEmpty(newConfiguration)) init();
    }, [newConfiguration]);
    
    useEffect(() => {
        setConfigurationsList(allConfigurations);
    },[allConfigurations]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey:   'id',
        });

        setSelectedState(newSelectedState);
    };

    const onHeaderSelectionChange = event => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = cloneDeep(selectedState);
        let selectedStateItems = {};

        const filteredData = orderBy(filterBy(configurationsList, dataState.filter), dataState.sort);
        filteredData.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
            if (checked) {
                selectedStateItems[idGetter(item)] = item;
            }

        });
        if (!checked) {
            selectedStateItems = {};
        }
        setSelectedState(newSelectedState);
    };

    const handleConfigurationMenu = (configuration, type) => {
        setSelectedConfiguration(configuration);
        if (type === 'edit') {
            setAction('edit');
        } else if (type === 'delete') {
            setAction('delete');
        } else if (type === 'saveAs') {
            setAction('saveAs');
        }
    };

    const actionsCell = props => {
        const isViewOwner = currentUser.id === props.dataItem.viewData.ownerId;
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu 
                    type="ConfigurationList"
                    configurationData={props.dataItem}
                    handleConfigurationMenu={(configuration, type) => handleConfigurationMenu(configuration, type)}
                    isViewOwner={isViewOwner}
                    isEditable={!props.dataItem.name.includes('Table Configuration')}
                />
            </td>
        );
    };

    const handleDelete = async () => {
        await deleteConfiguration(selectedConfiguration.id);
        setAction('');
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const defaultCell = props => {
        return (
            <td className={props.className} style={props.style}>
                {props.dataItem[props.field] ? <span className="material-icons-outlined">
                    check_box
                </span> : ''}
            </td>
        );
    };

    const refreshGrid = () => {
        if (currentUser && currentUser.id && activeNavCompany && activeNavCompany.id) init();
    };

    const handleDeleteConfigurations = () => {
        setAction('bulkdelete');
    };

    const handleBulkDelete = async () => {

        if (isEmpty(selectedState)) return;

        let filteredConfigurations = { ...selectedState };

        for (var key in filteredConfigurations) {
            if (filteredConfigurations[key] === false) {
                delete filteredConfigurations[key];
            }
        }

        const ids = Object.keys(filteredConfigurations);

        if (ids) {
            await bulkDeleteConfigurations(ids);
            setSelectedState({});
        }
    };

    const handleNameNavigation = dataItem => {
        return `${dataItem.viewData.viewUrl}&viewId=${dataItem.id}`;
    };

    const handleNav = async dataItem => {
        let viewUrl = dataItem.viewData.viewUrl.split('?')[1];
        const queryValues = queryString.parse(viewUrl);
        
        history.push(`${dataItem.viewData.viewUrl}&viewId=${dataItem.id}`);

        if (queryValues.equipment) {
            if (!isEmpty(navEquipment)) {
                let tempEquipment = navEquipment.filter(e => e.id === queryValues.equipment);
                setActiveNavEquipment(tempEquipment[0]);
                setNavEquipment({...tempEquipment[0]});
            }
        }

        // Equipment Dashboard
        if (queryValues.equipment) {
            const options = {extendedData: true};
            await fetchSingleEquipment(queryValues, options);
        }

        // System Dashboard
        if (queryValues.system) {
            await fetchSingleSite(queryValues);
            resetNavOptions('site');
        }
    };

    const nameCell = props => {
        if (props.dataItem.viewData && props.dataItem.viewData.viewUrl) {
            return (
                <td className={props.className} style={props.style}>
                    <Link
                        to={handleNameNavigation(props.dataItem)}
                        onClick={
                            (e) => {
                                if (!e.ctrlKey) {
                                    handleNav(props.dataItem);
                                }
                            }
                        }
                    >
                        {props.dataItem[props.field]}
                    </Link>
                </td>
            );
        } else {
            return (
                <td className={props.className} style={props.style}>
                    {props.dataItem[props.field]}
                </td>
            );
        }
    };

    return (
        <div className={classes.ConfigurationsTable}>
            <div className={classes.WorkbookModeContainer}>
                <BobWorkbookModeButton
                    handleWorkbookMode={handleWorkbookMode}
                    workbookMode={workbookModeEnabled}
                />
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                <div className={classes.ActionButtonContainer}>
                    <BobActionMenu
                        type="UserViewConfiguration"
                        handleDeleteConfigurations={() => handleDeleteConfigurations()}
                    />
                </div>
            </div>
            <div className={classes.GridContainer}>
                <div className={classes.Table}>
                    <div className={classes.TablePanel}>
                        <style>
                            { kendoGridInlineStyling }
                        </style>
                        <Grid
                            sortable
                            className={classes.KendoGrid}
                            data={kendoProcess(configurationsList ? configurationsList.map(item => ({
                                ...item,
                                'selected': selectedState[idGetter(item)],
                            })) : [], dataState)}
                            onDataStateChange={onDataStateChange}
                            {...dataState}
                            pageable={pageable}
                            reorderable
                            filterable={workbookModeEnabled}
                            dataItemKey={'id'}
                            selectedField={'selected'}
                            selectable={{
                                enabled: true,
                                drag:    false,
                                cell:    false,
                                mode:    'multiple'
                            }}
                            onSelectionChange={onSelectionChange}
                            onHeaderSelectionChange={onHeaderSelectionChange}
                        >
                            <Column
                                field="selected"
                                width="70px"
                                headerSelectionValue={
                                    orderBy(filterBy(configurationsList, dataState.filter), dataState.sort).length > 0 &&
                                    orderBy(filterBy(configurationsList, dataState.filter), dataState.sort).findIndex((item) => !selectedState[idGetter(item)]) === -1
                                }
                                filterable={false}
                                sortable={false}
                            />
                            <Column
                                field={'name'} 
                                title={'View & Configuration Name'} 
                                width="auto"
                                filter="text"
                                cell={nameCell}
                            />
                            <Column
                                field={'viewData.viewType'} title={'View Type'} width="auto"
                                filter="text"
                            />
                            <Column
                                field="entityName" title={'Entity Name'} width="auto"
                                filter="text"
                            />
                            <Column
                                field="sharedEmailsString"
                                title={'Shared With'}
                                width="auto"
                                filter="text"
                            />
                            <Column
                                field="isDefault"
                                title={'Default View'}
                                width="auto"
                                filter="text"
                                filterable={false}
                                cell={defaultCell}
                            />
                            <Column
                                field=""
                                title=""
                                width="auto"
                                filterable={false}
                                sortable={false}
                                cell={actionsCell}
                            />
                        </Grid>
                    </div>
                </div>
                {
                    action === 'edit' || action === 'saveAs' ?
                        <ConfirmConfiguration
                            action={action}
                            isFromConfiguratioinsTable={true}
                            toggleSaveConfigurationModal={()=> setAction('')}
                            setAction={() => setAction('')}
                            selectedConfiguration={selectedConfiguration}
                        />
                        : null
                }
                {
                    action === 'delete' || action === 'bulkdelete'?
                        <BobModal
                            title={'Delete Configuration'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setAction('');}}
                        >
                            <DeleteConfigurationModal
                                onConfirm={action === 'delete' ? handleDelete : handleBulkDelete}
                                onClose={() => setAction('')}
                                selectedConfiguration={selectedConfiguration}
                                bulkDelete={action === 'bulkdelete'}
                            />
                        </BobModal> : null
                }
                {
                    bobLoading.includes('fetchAllConfigurations') || bobLoading.includes('UpdateOrDeleteViewAndConfiguration')
                    || bobLoading.includes('SaveViewAndConfiguration') ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        activeNavEquipment:  state.bob.activeNavEquipment,
        bobLoading:          state.bob.bobLoading,
        allConfigurations:   state.configurationData.allConfigurations,
        currentUser:         state.currentUser,
        navEquipment:        state.bob.navEquipment,
        newConfiguration:    state.configurationData.newConfiguration,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...configurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigurationsTable));
